export default __webpack_public_path__ + "static/media/truck-icon.14f15d06.svg";